import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "../../components/ui";

const HIGHLIGHTS = [
  { num: "90", text: "秒左右完成，中途可退出" },
  { num: "3", text: "個選項：認識 / 不確定 / 不認識" },
  { num: "0", text: "分數，只用來決定起點" },
];

export function Intro() {
  const navigate = useNavigate();
  return (
    <div className="min-h-dvh box-border bg-cream flex flex-col pt-[60px] px-[max(26px,5vw)] pb-[34px]">
      <div className="flex items-center justify-between">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="text-[19px] text-ink3 bg-transparent border-0 p-0 cursor-pointer"
        >
          ←
        </button>
        <button
          type="button"
          onClick={() => navigate("/login?test_mode=1&next=/today")}
          className="text-[13px] font-grotesk font-semibold text-accent hover:underline bg-transparent border-0 p-0 cursor-pointer"
        >
          略過測驗直接使用 ›
        </button>
      </div>

      <div className="mt-[62px]">
        <div className="font-grotesk text-[11px] font-semibold tracking-[.16em] text-ink4">LEVEL TEST · 水平測試</div>
        <h2 className="mt-[14px] mb-0 text-[29px] leading-[1.3] font-bold text-ink">
          20 個詞，<br />找出你的起點
        </h2>
        <p className="mt-[14px] mb-0 text-[15px] leading-[1.75] text-ink2 [text-wrap:pretty]">
          不用從 the 開始背。測試會即時調難度：答對就跳更難，答錯就退回，最後估出你的詞彙量。
        </p>
      </div>

      <div className="mt-[34px] flex flex-col gap-[10px]">
        {HIGHLIGHTS.map((h) => (
          <div key={h.num} className="flex items-center gap-[14px] p-[16px] rounded-[14px] bg-white border border-line">
            <span className="font-grotesk text-[20px] font-semibold text-accent w-[30px]">{h.num}</span>
            <span className="text-[14.5px] text-ink">{h.text}</span>
          </div>
        ))}
      </div>

      <div className="mt-[24px] px-[17px] py-[16px] rounded-[16px] bg-paper border border-line-tab">
        <div className="text-[13.5px] leading-[1.65] text-ink2">誠實作答就好。高估自己只會讓你之後每天都在背不懂的詞。</div>
      </div>

      <div className="mt-auto pt-[24px]">
        <PrimaryButton onClick={() => navigate("/level-test")}>開始測試</PrimaryButton>
        <div className="mt-3 text-center">
          <button
            type="button"
            onClick={() => navigate("/login?test_mode=1&next=/today")}
            className="font-grotesk text-[13px] text-ink4 hover:text-ink cursor-pointer bg-transparent border-none p-0"
          >
            不想測驗？直接前往登入／註冊使用 →
          </button>
        </div>
      </div>
    </div>
  );
}
